import React, { createContext, useContext, useEffect, useState } from 'react';      
    
const TelegramContext = createContext();      
    
export const TelegramProvider = ({ children }) => {      
  const [telegramApp, setTelegramApp] = useState(null);      
  const [isReady, setIsReady] = useState(false);      
  const [userData, setUserData] = useState(null);    
  const [authData, setAuthData] = useState(null);   
  const [initializationError, setInitializationError] = useState(null);  
  
  useEffect(() => {        
    const initializeTelegram = () => {  
      try {  
        if (!window.Telegram) {  
          throw new Error('Telegram object not found');  
        }  
  
        if (!window.Telegram.WebApp) {  
          throw new Error('Telegram WebApp not found');  
        }  
  
        // Initialize Telegram WebApp  
        window.Telegram.WebApp.ready();        
        window.Telegram.WebApp.expand();        
          
        setTelegramApp(window.Telegram.WebApp);        
          
        // Get user data and init data  
        const webAppUser = window.Telegram.WebApp.initDataUnsafe?.user;        
        const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe;    
        const initData = window.Telegram.WebApp.initData;      
  
        if (!webAppUser || !initDataUnsafe || !initData) {  
          throw new Error('Required Telegram data is missing');  
        }  
  
        // Parse auth data  
        const authDataObj = {};      
        const params = new URLSearchParams(initData);      
        params.forEach((value, key) => {      
          authDataObj[key] = value;      
        });      
  
        setUserData(webAppUser);    
        setAuthData({    
          query_id: initDataUnsafe.query_id,    
          auth_date: initDataUnsafe.auth_date,    
          hash: params.get('hash'),    
          ...authDataObj    
        });      
  
        setIsReady(true);  
      } catch (error) {  
        setInitializationError(error.message);  
        console.error('Telegram initialization error:', error);  
      }  
    };  
  
    // Try to initialize immediately  
    initializeTelegram();  
  
    // Retry every 1 second for up to 5 attempts if initialization fails  
    let attempts = 0;  
    const maxAttempts = 5;  
    const retryInterval = setInterval(() => {  
      if (!isReady && attempts < maxAttempts) {  
        attempts++;  
        initializeTelegram();  
      } else {  
        clearInterval(retryInterval);  
      }  
    }, 1000);  
  
    return () => clearInterval(retryInterval);  
  }, []);      
  
  if (initializationError) {  
    return (  
      <div className="h-screen flex items-center justify-center">  
        <div className="text-center p-4">  
          <p className="text-red-500">Failed to initialize: {initializationError}</p>  
          <p className="mt-2">Please ensure you're opening this in Telegram.</p>  
        </div>  
      </div>  
    );  
  }  
    
  if (!isReady) {      
    return (      
      <div className="h-screen flex items-center justify-center">      
        <div className="text-center p-4">      
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>      
          <p className="mt-4">Initializing Telegram WebApp...</p>      
          <p className="text-sm text-gray-500 mt-2">Please wait...</p>  
        </div>      
      </div>      
    );      
  }      
    
  return (      
    <TelegramContext.Provider value={{   
      telegramApp,   
      userData,   
      authData,  
      isReady   
    }}>      
      {children}      
    </TelegramContext.Provider>      
  );      
};      
    
export const useTelegram = () => {      
  const context = useContext(TelegramContext);      
  if (!context) {      
    throw new Error('useTelegram must be used within a TelegramProvider');      
  }      
  return context;      
};  
